<template>
<v-card height="630" class="elevation-1">
  <v-card-title class="subtitle-1 ml-3 mt-0 py-2">

    Lista de Ocorrência
    
    <v-spacer></v-spacer>

    <v-btn text>
      <v-icon size="18" class="ml-1">fas fa-ellipsis-h</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text class="pb-0">

    <v-divider></v-divider>

    <v-simple-table 
      fixed-header 
      class="py-0" 
      height="520">
      <template v-slot:default>
        <thead>

          <tr>
            <th class="text-center">Ficha</th>
            <th class="text-center">Natureza</th>
            <th class="text-center">Status</th>
            <th class="text-center">Veículo</th>
            <th class="text-center">Tempo</th>
          </tr>
        </thead>
        <tbody>

          <tr 
            v-for="(item,index) in attendances" 
            :key="index"
            @click="regulation(item)"
            :class="getColorRow(item)">

            <td class="text-center">
             <v-tooltip bottom>
                <template v-slot:[`activator`]="{ on, attrs }">
                  <v-btn
                    aria-label="asdsd"
                    class="elevation-0 transparent"
                    v-bind="attrs"
                    v-on="on" >
                  <div :class="getColorBtn(item)">{{ item.id }}</div>
                </v-btn>
                </template>
               <span v-if="item.regulatory_physician"> {{ item.regulatory_physician.name }} </span>
               <span v-else> Aguardando Médico Regulador </span>
              </v-tooltip>
      
            </td>

            <td class="text-center">{{ item.reason }}</td>

            <td class="text-center">
              
              <v-chip 
                width="50" 
                class="ma-0" 
                :color="getColorStatus(item.status)" 
                label
                small>
                <strong>{{ item.status }}</strong>
              </v-chip>
            </td>

            <td class="text-center">SIGLA - placa</td>

            <td :class="getColorCol(item)">

              {{item.data}}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card-text>
</v-card>
</template>

<script>
var moment = require("moment-timezone");
export default {
  name: "ListOccurrences",
  props: ["doctor"],
  data: () => ({
    selectedCallId: -1,
  }),

  computed: {

    attendances() {

      let values = this.$store.getters.getAttendances?this.$store.getters.getAttendances:[];
      let ocorrencias = [];
      values.forEach( (element) => {


        let referenceDate = this.doctor ? element.updated_at : element.created_at;
        referenceDate = moment.utc( new Date(referenceDate) ).tz("America/Manaus")

        let horatual = moment(new Date());
        let diference  = moment.duration(horatual.diff(referenceDate));
        let day_diference = `${diference.hours()}h ${diference.hours()}min`;

        if ( diference.days() >0 ){
          day_diference = `${diference.days()}dias `+ day_diference;
        }
        
        let statusname = this.getStrStatus(
          element.status ? element.status.status : "Open"
        );

        if (element.cancellation_reason !== null) {
          statusname = "Cancelado";
        }

        ocorrencias.push({
          ...element,
          id: element.id,
          status: statusname,
          data: day_diference,
          icon: element.device === "desktop" ? "fas fa-desktop" : "fas fa-mobile",
        });
      });
      ocorrencias = ocorrencias.sort( (a,b) => {
        if( a.id === b.id ) {
          return 0;
        } else {
          return a.id < b.id ? 1: -1;
        }
      })

      return ocorrencias;
    },
  },

  watch: {},

  methods: {

    getColorStatus(statusname){ 
      if ( statusname == "Aguardando" ){
        return "#ffcfe0";
      } else if( statusname == "Andamento" ){
        return "#dddddb";
      } else if ( statusname == "Finalizado"){
        return "#c2e2d5"
      } else{
        return "#82B1FF";
      }
    },

    getStrStatus(statusname){
      if ( statusname == "Open" ){
        return "Aguardando";
      } else if ( statusname == "In progress" ){
        return "Andamento";
      } else if ( statusname == "Closed" ){
        return "Finalizado"
      } else {
        return statusname;
      }
    },

    getColorRow (item){
      return this.isSelected(item) ? 'teal accent-3' : '';
    },

    getColorBtn (item){
      return this.isSelected(item) ? 'white&#45;&#45;text text-center' : 'primary&#45;&#45;text text-center';
    },

    getColorCol (item){
      return this.isSelected(item) ? 'white--text text-center' : ' text-center';
    },

    getColorIcon (item){
      return this.isSelected(item) ? 'white--text ml-0' : 'ml-0';
    },

    isSelected (item){
      return this.doctor && this.selectedCallId && this.selectedCallId === item.id;
    },

    regulation(item) {

      if (item.status != "Closed") {

        this.selectedCallId = item.id;
        this.$store.dispatch("setSolicitationInfoCall", item);
        this.$store.commit('setCallSelected',item)
      }
    },
    clearAttendance() {

      this.selectedCallId = undefined;
      this.$store.dispatch("setSolicitationInfoCall", undefined);
    },
    timeDifference(tarmDate) {

      let now = moment();
      let diff = now.diff(tarmDate);
      let duration = moment.duration(diff);
      let hour = Math.floor(duration.asHours());
      let timeFormated = moment.utc(diff).format("D[ dia(s)], H[ hora(s) e ] m[ minuto(s) atrás]");
      //if (Number(hour) > 0) timeFormated = hour + " horas, " + timeFormated;
      return timeFormated
    },
  },
};
</script>

<style scoped>
</style>